export const crmMessageSchedule = {
  status: {
    scheduled: "配信予定",
    processing: "処理中",
    done: "完了",
  },
};
